export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const DEFAULT_LOCALE = 'vi';

export const ADD_USER_INFO = 'ADD_USER_INFO';
export const REMOVE_USER_INFO = 'REMOVE_USER_INFO';

export const ADD_INFO_EKYC = 'ADD_INFO_EKYC';
export const REMOVE_INFO_EKYC = 'REMOVE_INFO_EKYC';

export const GET_FCM_TOKEN = 'GET_FCM_TOKEN';
export const GET_MSISDN = 'GET_MSISDN';

export const IS_APP = 'IS_APP';

export const ProgressAction = {
  SHOW_PROGRESS: 'SHOW_PROGRESS',
  HIDE_PROGRESS: 'HIDE_PROGRESS',
  RESET_PROGRESS: 'RESET_PROGRESS',
};

export const AuthorizeAction = {
  LOGIN_ACTION: 'LOGIN_ACTION',
  LOGOUT_ACTION: 'LOGOUT_ACTION',
  LOGIN_3G_4G: 'LOGIN_3G_4G',
};

export const AuthorizeVplusAction = {
  LOGIN_VPLUS_ACTION: 'LOGIN_VPLUS_ACTION',
  LOGOUT_VPLUS_ACTION: 'LOGOUT_VPLUS_ACTION',
  VPLUS_TOKEN_DEV: 'VPLUS_TOKEN_DEV',
  VPLUS_TOKEN_HOIVIEN: 'VPLUS_TOKEN_HOIVIEN',
  VPLUS_TOKEN_HOIVIEN_ESC: 'VPLUS_TOKEN_HOIVIEN_ESC',
  VPLUS_USERINFO: 'VPLUS_USERINFO',
  VPLUS_USERPROMOMENU: 'VPLUS_USERPROMOMENU',
  VPLUS_IS_UPDATE_EMAIL: 'VPLUS_IS_UPDATE_EMAIL',
};

export const AuthorizeLoyaltyAction = {
  LOGIN_LOYALTY_ACTION: 'LOGIN_LOYALTY_ACTION',
  LOGOUT_LOYALTY_ACTION: 'LOGOUT_LOYALTY_ACTION',
  // VPLUS_TOKEN_DEV: 'VPLUS_TOKEN_DEV',
  // VPLUS_TOKEN_HOIVIEN: 'VPLUS_TOKEN_HOIVIEN',
  // VPLUS_TOKEN_HOIVIEN_ESC: 'VPLUS_TOKEN_HOIVIEN_ESC',
  LOYALTY_USERINFO: 'LOYALTY_USERINFO',
  // VPLUS_USERPROMOMENU: 'VPLUS_USERPROMOMENU',
  // VPLUS_IS_UPDATE_EMAIL: 'VPLUS_IS_UPDATE_EMAIL',
};

export const QRCodeRoaming = {
  SET_DATA_QUERY_TRANSACTION_INFO: 'SET_DATA_QUERY_TRANSACTION_INFO',
};

export const FlowType = {
  IS_LOYALTY: "LOYALTY",
  IS_VPLUS: "VPLUS",
};